import { Component, inject, OnDestroy, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast-host',
  standalone: true,
  template: `
    @if (current(); as toast) {
      <div
        class="fixed bottom-8 left-1/2 z-[100] -translate-x-1/2 animate-[fadeInUp_0.25s_ease-out]"
        [class]="toast.type === 'success'
          ? 'rounded-2xl bg-[#171717] px-6 py-3.5 shadow-[0_10px_40px_rgba(0,0,0,0.25)]'
          : 'rounded-2xl bg-[#b42318] px-6 py-3.5 shadow-[0_10px_40px_rgba(180,35,24,0.25)]'"
      >
        <div class="flex items-center gap-2.5">
          @if (toast.type === 'success') {
            <svg class="h-5 w-5 shrink-0 text-[#5abb67]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
              <path d="M8 12.5L10.5 15L16 9.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          } @else {
            <svg class="h-5 w-5 shrink-0 text-white" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
              <path d="M12 8V13M12 16V16.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          }
          <span class="text-sm font-semibold text-white">{{ toast.message }}</span>
        </div>
      </div>
    }
  `,
  styles: [
    `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translate(-50%, 1rem);
        }
        to {
          opacity: 1;
          transform: translate(-50%, 0);
        }
      }
    `,
  ],
})
export class ToastHostComponent implements OnDestroy {
  private readonly toastService = inject(ToastService);
  protected readonly current = signal<Toast | null>(null);
  private sub: Subscription;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    this.sub = this.toastService.toast$.subscribe((toast) => {
      if (this.timeoutId) clearTimeout(this.timeoutId);
      this.current.set(toast);
      this.timeoutId = setTimeout(() => this.current.set(null), 3000);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }
}
